"use client";
import { useSession } from "next-auth/react";
import Image from "next/image";
import Link from "next/link";
import { openMenu } from "../toggleMenu";
import Nav from "./Nav";
export default function Header4({
  parentClass = "rainbow-header header-default header-not-transparent header-sticky",
  btnClass = "btn-default btn-small round",
}) {
  const { data: session } = useSession()
  
  return (
    <header className={parentClass}>
      <div className="container position-relative">
        <div className="row align-items-center row--0">
          <div className="col-lg-3 col-md-6 col-4">
            <div className="logo">
              <Link href={`/`}>
                <Image
                  className="logo-light"
                  alt="Corporate Logo"
                  src="/images/SB_hvit.png"
                  width={288}
                  height={100}
                />
                <Image
                  className="logo-dark"
                  alt="Corporate Logo"
                  src="/images/sbtech_logo.webp"
                  width={288}
                  height={100}
                />
              </Link>
            </div>
          </div>
          <div className="col-lg-9 col-md-6 col-8 position-static">
            <div className="header-right">
              <nav className="mainmenu-nav d-none d-lg-block">
                <ul className="mainmenu">
                  <Nav />
                </ul>
              </nav>
              {/* Start Header Btn  */}
              <div className="header-btn">
                {session?.user ? (
                  <a
                    className={btnClass}
                    href="/admin"
                  >
                    SB Cloud
                  </a>
                ) : (
                  <a
                    className={btnClass}
                    href="/company/login"
                  >
                    Login
                  </a>
                )}
              </div>
              {/* End Header Btn  */}
              {/* Start Mobile-Menu-Bar */}
              <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                <div className="hamberger">
                  <button onClick={openMenu} className="hamberger-button">
                    <i className="feather-menu" />
                  </button>
                </div>
              </div>
              {/* Start Mobile-Menu-Bar */}

            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
